export const BOOKING_CONFIG = {
  // Cal.com slug or custom link (can also be overridden via REACT_APP_CAL_LINK)
  calLink: process.env.REACT_APP_CAL_LINK || "akash-zaheer-px3sad/30min",
  namespace: "30min",
  title: "Book a Strategy Call",
  subtitle: "30-min technical architecture & project consultation",
  brandColor: "#14b8a6", // Vibrant brand teal
};
